import { ObjectType, Field, Int } from '@nestjs/graphql'

@ObjectType()
export class ArcFollowerStatsDto {
  @Field(t => Int)
  penNameFollowerCount!: number

  @Field(t => Int)
  arcTeamFollowerCount!: number

  @Field(t => Int)
  arcTeamMemberCount!: number
}
